import { Object3D, Quaternion, Vector3 } from "three";

import { toArray } from "../helpers/math-helpers";

export function encodeParcel(character: Object3D, camera: Object3D): string {
  // Calculate grid position
  let x = Math.floor((character.position.x + window.BITMAP_DATA.gridWidthHalf) / window.BITMAP_DATA.columnSize)
  let y = Math.floor((character.position.z + window.BITMAP_DATA.gridWidthHalf) / window.BITMAP_DATA.columnSize)

  if(window.GRID_DATA && window.GRID_DATA[y] && window.GRID_DATA[y][x]) {
    for(let i=0; i<window.GRID_DATA[y][x].length; i++) {
      // Retrieve m-frame
      const frameElement = window.GRID_DATA[y][x][i]
      const frameHalfSize = frameElement.getAttribute('size')/2
      const frameLeft = parseInt(frameElement.getAttribute('x')) - frameHalfSize
      const frameRight = parseInt(frameElement.getAttribute('x')) + frameHalfSize
      const frameBack = parseInt(frameElement.getAttribute('z')) - frameHalfSize
      const frameFront = parseInt(frameElement.getAttribute('z')) + frameHalfSize
      // Player is on parcel
      if(character.position.x >= frameLeft && character.position.x <= frameRight &&
          character.position.z >= frameBack && character.position.z <= frameFront) {
        return frameElement.getAttribute('id')
      }
    }
  }
  // Player is on street
  return null;
}

export function encodeCharacterAndCamera(character: Object3D, camera: Object3D): string {
  return [
    ...toArray(character.position),
    ...toArray(character.quaternion),
    ...toArray(camera.position),
    ...toArray(camera.quaternion),
  ].join(",");
}

export function decodeCharacterAndCamera(pathname: string, hash: string): {
  character: { position: Vector3; quaternion: Quaternion };
  camera: { position: Vector3; quaternion: Quaternion };
} {
  // Parcel spawn
  if(pathname.includes('/parcel/') && window.BITMAP_DATA.txns[pathname.substring(8)]) {
    const parcel = window.BITMAP_DATA.txns[pathname.substring(8)]
    const size = parcel.size * window.BITMAP_DATA.columnSize - window.BITMAP_DATA.streetSize
    const sizeHalf = (size) / 2
    const xPos = parcel.x * window.BITMAP_DATA.columnSize - 1 - window.BITMAP_DATA.gridWidthHalf
    const zPos = parcel.y * window.BITMAP_DATA.columnSize + size + 1 - window.BITMAP_DATA.gridWidthHalf
    return {
      character: {
        position: new Vector3(xPos, 1, zPos),
        quaternion: new Quaternion(0, 0, 0, 0)
      },
      camera: {
        position: new Vector3(xPos-1.5, 3, zPos+3.5),
        quaternion: new Quaternion(0, 0, 0, 0)
      }
    }
  }

  // Extract url position
  const values = hash.split(",").map(Number);

  // Calculate grid position
  let x = Math.floor((values[0] + window.BITMAP_DATA.gridWidthHalf) / window.BITMAP_DATA.columnSize)
  let y = Math.floor((values[2] + window.BITMAP_DATA.gridWidthHalf) / window.BITMAP_DATA.columnSize)

  // Check is inside parcel
  if(window.GRID_DATA && window.GRID_DATA[y] && window.GRID_DATA[y][x]) {
    for(let i=0; i<window.GRID_DATA[y][x].length; i++) {
      // Retrieve m-frame
      const frameElement = window.GRID_DATA[y][x][i]
      const frameHalfSize = frameElement.getAttribute('size')/2
      const frameLeft = parseInt(frameElement.getAttribute('x')) - frameHalfSize
      const frameRight = parseInt(frameElement.getAttribute('x')) + frameHalfSize
      const frameBack = parseInt(frameElement.getAttribute('z')) - frameHalfSize
      const frameFront = parseInt(frameElement.getAttribute('z')) + frameHalfSize
      // Player is on parcel
      if(values[0] >= frameLeft && values[0] <= frameRight &&
          values[2] >= frameBack && values[2] <= frameFront) {
        // Calculate parcel spawn
        const parcel = window.BITMAP_DATA.txns[frameElement.getAttribute('id')]
        const size = parcel.size * window.BITMAP_DATA.columnSize - window.BITMAP_DATA.streetSize
        const sizeHalf = (size) / 2
        const xPos = parcel.x * window.BITMAP_DATA.columnSize - 1 - window.BITMAP_DATA.gridWidthHalf
        const zPos = parcel.y * window.BITMAP_DATA.columnSize + size + 1 - window.BITMAP_DATA.gridWidthHalf
        return {
          character: {
            position: new Vector3(xPos, 1, zPos),
            quaternion: new Quaternion(0, 0, 0, 0)
          },
          camera: {
            position: new Vector3(xPos-1.5, 3, zPos+3.5),
            quaternion: new Quaternion(0, 0, 0, 0)
          }
        }
      }
    }
  }

  // Street accurate position
  return {
    character: {
      position: new Vector3(values[0], values[1], values[2]),
      quaternion: new Quaternion(values[3], values[4], values[5], values[6]),
    },
    camera: {
      position: new Vector3(values[7], values[8], values[9]),
      quaternion: new Quaternion(values[10], values[11], values[12], values[13]),
    },
  };
}
